/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".item[_ngcontent-%COMP%]{height:120px;width:120px}.item-wrapper[_ngcontent-%COMP%]{width:100%}.item-description[_ngcontent-%COMP%]{padding:1rem;line-height:1.75;letter-spacing:.2px;font-size:12px}.item-ask[_ngcontent-%COMP%]{position:relative;top:-2px}@media (max-width:368px){.item[_ngcontent-%COMP%]{height:80px;width:80px}}"];
export { styles as styles };
